class Boolean {
  static isTrue(value) {
    if (value === true) return true;

    if (typeof value === "string") {
      const val = value.trim().toLowerCase();
      return val === "true" || val === "1";
    }

    return value === 1;
  }

  static isFalse(value) {
    if (value === null || value === undefined) return true;

    if (typeof value === "string") {
      const val = value.trim().toLowerCase();
      return val === "false" || val === "0" || val === "";
    }

    return value === false || value === 0;
  }
}

export default Boolean;
